import React from "react";
import { Box } from "@mui/material";
import DeviceManager from "./DeviceManager";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../modals/AnimatedModal";
import DevicesIcon from "@mui/icons-material/Devices";

export default function DevicesListModal({ show, closeModal }) {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="80%"
      maxWidth="1200px"
    >
      <ModalHeader
        title="Dispositivos Registrados"
        icon={DevicesIcon}
        onClose={closeModal}
      />
      <ModalContent padding={0}>
        <Box sx={{ px: 2, pb: 2 }}>
          <DeviceManager />
        </Box>
      </ModalContent>
    </AnimatedModal>
  );
}
